import { errorApiRef, useApi } from '@mainstage/core-plugin-api';
import { Button, ButtonProps } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { useEffect, useState } from 'react';
import useCopyToClipboard from 'react-use/lib/useCopyToClipboard';
import { WbTooltip } from '../WbTooltip';

export function CopyButton({
  text,
  tooltipDelay = 1e3,
  tooltipText = 'Text copied to clipboard',
  children,
  hideIcon,
  ...buttonProps
}: {
  text: string;
  tooltipDelay?: number;
  tooltipText?: string;
  hideIcon?: boolean;
} & ButtonProps) {
  const errorApi = useApi(errorApiRef);
  const [open, setOpen] = useState(false);
  const [{ error }, copyToClipboard] = useCopyToClipboard();
  useEffect(() => {
    if (error) {
      errorApi.post(error);
    }
  }, [error, errorApi]);
  const handleCopyClick = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setOpen(true);
    copyToClipboard(text);
    setTimeout(() => setOpen(false), tooltipDelay);
  };
  return (
    <WbTooltip
      title={tooltipText}
      id="copy-text-tooltip"
      placement="top"
      leaveDelay={tooltipDelay}
      open={open}
      setOpen={setOpen}
      disableHoverListener
      disableFocusListener
    >
      <Button
        {...buttonProps}
        aria-label="copy to clipboard"
        onClick={handleCopyClick}
        startIcon={hideIcon ? null : <FileCopyIcon />}
      >
        {children || 'Copy'}
      </Button>
    </WbTooltip>
  );
}
